import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

const EventLog = ({ assetId }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAuthHeader = () => {
    const token = localStorage.getItem("authToken");
    return { Authorization: `Bearer ${token}` };
  };

  useEffect(() => {
    if (assetId) {
      loadLogs();
    }
  }, [assetId]);

  const loadLogs = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API_BASE_URL}/asset/${assetId}/event-logs`,
        { headers: getAuthHeader() }   // ✅ FIX 1
      );

      // ✅ FIX 2 (handle both array & object)
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.data || [];

      setLogs(data);
    } catch (err) {
      console.error("Failed to load event logs", err);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-3">
      <h5 className="mb-3">Event Log</h5>

      <div className="table-responsive">
        <table className="table table-bordered table-striped table-sm mb-0">
          <thead>
            <tr>
              <th>Added By</th>
              <th>Type</th>
              <th>Info</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {loading && (
              <tr>
                <td colSpan="4" className="text-center">
                  Loading...
                </td>
              </tr>
            )}

            {!loading && logs.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No event logs found
                </td>
              </tr>
            )}

            {logs.map((log) => (
              <tr key={log.log_id}>
                <td>
                  {log.first_name} {log.last_name} ({log.employee_id})
                </td>
                <td>{log.log_type}</td>
                <td>{log.log_info}</td>
                <td>
                  {new Date(log.log_datetime).toLocaleDateString("en-GB")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EventLog;
